var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "ORDER",
                      expression: "`ORDER`",
                    },
                  ],
                  attrs: { status: "primary" },
                  on: { click: _vm.applyFun },
                },
                [_vm._v("下单")]
              ),
              _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "EXPORT",
                      expression: "`EXPORT`",
                    },
                  ],
                  on: { click: _vm.deriveFun },
                },
                [_vm._v("导出")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    color: "#848484",
                    display: "flex",
                    "line-height": "28px",
                  },
                },
                [
                  !_vm.showdiv
                    ? _c(
                        "div",
                        [
                          _c("a-input", {
                            staticStyle: {
                              width: "160px",
                              "margin-right": "1rem",
                            },
                            attrs: { placeholder: "订单号", clearable: "" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.queryByPage()
                              },
                            },
                            model: {
                              value: _vm.queryCondition.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "applyOrderCode",
                                  $$v
                                )
                              },
                              expression: "queryCondition.applyOrderCode",
                            },
                          }),
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "1rem",
                              },
                              attrs: { placeholder: "订单状态", clearable: "" },
                              model: {
                                value: _vm.queryCondition.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "orderStatus",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.orderStatus",
                              },
                            },
                            _vm._l(
                              _vm.selectLists.PromotionOrderStatus,
                              function (item) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: item.code,
                                    attrs: { value: item.code },
                                  },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      !_vm.showdiv
                        ? _c(
                            "vxe-button",
                            {
                              attrs: { status: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.queryByPage(1)
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          )
                        : _vm._e(),
                      !_vm.showdiv
                        ? _c(
                            "vxe-button",
                            {
                              staticClass: "filter-search-item",
                              on: { click: _vm.resetForm },
                            },
                            [_vm._v("重置")]
                          )
                        : _vm._e(),
                      _c("vxe-button", { on: { click: _vm.cb } }, [
                        _vm._v(
                          " " + _vm._s(_vm.showdiv ? "收起" : "更多选项") + " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("a-collapse", [
                _vm.showdiv
                  ? _c("div", [
                      _vm.showdiv
                        ? _c(
                            "div",
                            [
                              _c("SiftMaterialRequisition", {
                                attrs: {
                                  data: _vm.queryCondition,
                                  list: _vm.selectLists,
                                },
                                on: {
                                  "update:data": function ($event) {
                                    _vm.queryCondition = $event
                                  },
                                },
                              }),
                              _c("br"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "padding-bottom": "10px",
                                  },
                                  attrs: { slot: "footer" },
                                  slot: "footer",
                                },
                                [
                                  _c(
                                    "vxe-button",
                                    { on: { click: _vm.resetForm } },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "vxe-button",
                                    {
                                      attrs: { status: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.queryByPage(1)
                                        },
                                      },
                                    },
                                    [_vm._v("搜索")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              attrs: {
                loading: _vm.listLoading,
                align: _vm.allAlign,
                "max-height":
                  _vm.$store.state.app.height - 130 < 500
                    ? 500
                    : _vm.$store.state.app.height - 130,
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                data: _vm.tableData,
              },
              on: { "sort-change": _vm.listSortMethod },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "applyOrderCode",
                  title: "订单编号",
                  width: "130",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "orgName", title: "申领部门", width: "130" },
              }),
              _c("vxe-column", {
                attrs: { field: "applyMan", title: "申领人", width: "130" },
              }),
              _c("vxe-column", {
                attrs: { field: "receiverName", title: "收货人", width: "130" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "receivePhone",
                  title: "收货人联系方式",
                  width: "130",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "applyTime", title: "申领日期", width: "130" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "orderMaterialCount",
                  title: "订单总项数",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "orderNums",
                  title: "申领总数量",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "orderTotalSums",
                  title: "申领总金额",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "approveCommitDate",
                  title: "审批通过日期",
                  width: "130",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "approveNums",
                  title: "审批总数量",
                  width: "100",
                },
              }),
              _vm._v('" '),
              _c("vxe-column", {
                attrs: {
                  field: "approveTotalSums",
                  title: "审批总金额",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "receiveTime",
                  title: "签收时间",
                  width: "130",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "orderStatus",
                  title: "订单状态",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.orderStatus === "0"
                          ? _c("span", [_vm._v("录入中")])
                          : row.orderStatus === "1"
                          ? _c("span", [_vm._v("审核中")])
                          : row.orderStatus === "2"
                          ? _c("span", [_vm._v("审核通过")])
                          : row.orderStatus === "3"
                          ? _c("span", [_vm._v("已驳回")])
                          : row.orderStatus === "4"
                          ? _c("span", [_vm._v("部分收货")])
                          : row.orderStatus === "5"
                          ? _c("span", [_vm._v("已收货")])
                          : row.orderStatus === "6"
                          ? _c("span", [_vm._v("不通过")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "160",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "operate" },
                          [
                            row.orderStatus === "0" || row.orderStatus === "3"
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "UPDATE",
                                        expression: "`UPDATE`",
                                      },
                                    ],
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "VIEW",
                                    expression: "`VIEW`",
                                  },
                                ],
                                attrs: {
                                  size: "small",
                                  type: "link",
                                  status: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.inspectFun(row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            row.orderStatus === "1"
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "PROCESS",
                                        expression: "`PROCESS`",
                                      },
                                    ],
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.approveFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("审核")]
                                )
                              : _vm._e(),
                            (row.orderStatus === "2" ||
                              row.orderStatus === "4") &&
                            _vm.user.userNo == row.createUser
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "RECEIVE",
                                        expression: "`RECEIVE`",
                                      },
                                    ],
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.receiveFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("收货")]
                                )
                              : _vm._e(),
                            row.orderStatus === "0" || row.orderStatus === "3"
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "DELETE",
                                        expression: "`DELETE`",
                                      },
                                    ],
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      status: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFun(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.changePage },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "选择导出项", width: "400px" },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.ExportItem,
                callback: function ($$v) {
                  _vm.ExportItem = $$v
                },
                expression: "ExportItem",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("导出全部")]),
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("导出当前页")]),
              _c("a-radio", { attrs: { value: 2, disabled: _vm.disabled } }, [
                _vm._v("导出已选择项"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: {
                    size: "small",
                    status: "primary",
                    loading: _vm.outExcelButtonLocading,
                  },
                  on: { click: _vm.exportXlsxFun },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ReceiveMaterialDialog", {
        attrs: {
          visible: _vm.receiveDialog,
          order: _vm.rowOrder,
          materialtable: _vm.materialList,
          OrderLogistics: _vm.OrderLogisticsList,
        },
        on: {
          "update:visible": function ($event) {
            _vm.receiveDialog = $event
          },
          "update:order": function ($event) {
            _vm.rowOrder = $event
          },
          "update:materialtable": function ($event) {
            _vm.materialList = $event
          },
          "update:OrderLogistics": function ($event) {
            _vm.OrderLogisticsList = $event
          },
          "update:order-logistics": function ($event) {
            _vm.OrderLogisticsList = $event
          },
          receiveSubmit: _vm.receiveSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }